module.exports = __webpack_public_path__ + "static/img/analyze.93ca373.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/analyze.png
// module id = KO5b
// module chunks = 1